var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 73,
    viewBox: "0 0 71 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1511_10572)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.4603,
    cy: 34.8431,
    rx: 34.8431,
    ry: 34.8431,
    fill: "#DAB90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8035 34.8431C68.8035 53.258 53.8752 68.1863 35.4603 68.1863C17.0454 68.1863 2.11719 53.258 2.11719 34.8431C2.11719 16.4282 17.0454 1.5 35.4603 1.5C53.8752 1.5 68.8035 16.4282 68.8035 34.8431Z",
    stroke: "white",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1511_10572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6953 19.5C27.1453 19.5 20.1953 26.45 20.1953 35C20.1953 43.55 27.1453 50.5 35.6953 50.5C44.2453 50.5 51.1953 43.55 51.1953 35C51.1953 26.45 44.2453 19.5 35.6953 19.5ZM34.3753 33.08C34.6453 33.35 35.0053 33.5 35.3853 33.5H36.0053C37.1853 33.5 38.3053 33.96 39.1453 34.8C39.9753 35.64 40.4453 36.75 40.4453 37.94C40.4453 39.97 39.0553 41.67 37.1953 42.2V42.58C37.1953 43.41 36.5153 44.08 35.6953 44.08C34.8653 44.08 34.1953 43.41 34.1953 42.58V42.38H32.4453C31.6253 42.38 30.9453 41.71 30.9453 40.88C30.9453 40.05 31.6253 39.38 32.4453 39.38H36.0053C36.7953 39.38 37.4453 38.73 37.4453 37.94C37.4453 37.55 37.2953 37.19 37.0153 36.92C36.7453 36.65 36.3853 36.5 36.0053 36.5H35.3853C34.2153 36.5 33.1053 36.04 32.2553 35.21C31.8405 34.7969 31.5113 34.3061 31.2865 33.7655C31.0617 33.225 30.9457 32.6454 30.9453 32.06C30.9453 30.03 32.3253 28.33 34.1953 27.81V27.42C34.1953 26.59 34.8653 25.92 35.6953 25.92C36.5153 25.92 37.1953 26.59 37.1953 27.42V27.62H38.9453C39.7653 27.62 40.4453 28.29 40.4453 29.12C40.4453 29.95 39.7653 30.62 38.9453 30.62H35.3853C34.5953 30.62 33.9453 31.27 33.9453 32.06C33.9453 32.45 34.0953 32.81 34.3753 33.08Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1511_10572",
    x: 0.617188,
    y: 0,
    width: 69.6875,
    height: 72.6863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.633333 0 0 0 0 0.534891 0 0 0 0 0.0158333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1511_10572"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1511_10572",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_10572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(19.6953 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashBtn);
export default __webpack_public_path__ + "static/media/cash-btn.71a80cc36b5f5be1737b5188316dfcc7.svg";
export { ForwardRef as ReactComponent };